import React, { useCallback, useMemo } from 'react';
import classNames from 'classnames';

import useAIVoiceSearch from 'js/src/components/app/VoiceSelectionModal/useAIVoiceSearch';
import type { TypeInputKeyboardEvent } from 'js/src/components/common/ui/TextInput';
import TextInput from 'js/src/components/common/ui/TextInput';

interface AIVoiceSearchProps {
    className?: string;
}

const AIVoiceSearch: React.FC<AIVoiceSearchProps> = ({ className }) => {
    const { searchTerm, onChangeSearchTerm } = useAIVoiceSearch();

    const text = useMemo(() => {
        return searchTerm ?? '';
    }, [searchTerm]);

    const onSearchTermChange = useCallback(
        (text: string) => {
            const value = text || null;
            onChangeSearchTerm(value);
        },
        [onChangeSearchTerm],
    );

    const clearSearchTerm = useCallback(() => {
        onChangeSearchTerm(null);
    }, [onChangeSearchTerm]);

    const handleKeyDown = useCallback((e: TypeInputKeyboardEvent) => {
        const target = e.target as HTMLInputElement;
        if (e.key === 'Enter') {
            target.blur();
        }
    }, []);

    return (
        <div className={classNames(className)}>
            <TextInput
                text={text}
                iconLeft="search"
                placeholder="Search by speaker name, tone, style or accent"
                submitOnBlur
                onSubmit={onSearchTermChange}
                onKeyDown={handleKeyDown}
                showClear
                onClear={clearSearchTerm}
            />
        </div>
    );
};

export default AIVoiceSearch;
